import type {QueryClient} from '@tanstack/react-query';
/** Only vault invalidations are forwarded. Receiving one cannot echo it back. */
export function vaultQuerySync(client:QueryClient,send:()=>void){
 let receiving=false,timer:ReturnType<typeof setTimeout>|undefined;
 const schedule=()=>{if(timer)clearTimeout(timer);timer=setTimeout(()=>{timer=undefined;send();},80);};
 const unsubscribe=client.getQueryCache().subscribe(event=>{
  if(receiving||event.type!=='updated'||event.action.type!=='invalidate'||event.query.queryKey[0]!=='vault')return;
  schedule();
 });
 // invalidateQueries is idempotent for an already stale query. A completed vault
 // write must still notify the other window even when no invalidate event fires.
 const mutations=client.getMutationCache().subscribe(event=>{
  if(event.type==='updated'&&event.action.type==='success'&&event.mutation.options.meta?.vaultWrite===true){
   const result=event.mutation.state.data as {applied?:boolean}|null|undefined;
   if(result?.applied!==false)schedule(); // Previews keep both windows' editing state untouched.
  }
 });
 return {
  receive(){receiving=true;try{void client.invalidateQueries({queryKey:['vault']}).catch(()=>{});}finally{receiving=false;}},
  dispose(){unsubscribe();mutations();if(timer)clearTimeout(timer);},
 };
}
